<template>
  <div id="selector-category">
    <div class="list">
      <div class="item" v-for="(category, index) in list" @click="select(category)"
        :class="{ selected: category.id == $route.params.category }">
        <!-- {{'miclive.standing.category'| translate2}} {{ category.name }} -->
        {{'miclive.standing.category' | translate}} {{category.name}}
      </div>
    </div>
  </div>
</template>

<script>
  import i18n from '@/i18n'
  export default {
    name: "Categories",
    props: {
      list: Object,
    },
    data() {

      return {
      };
    },
    computed: {

    },
    methods: {
      load() {},
      select(category) {
        var self = this;
        // this.$route.params.category = category.id;
        this.$overlay.loading();
        this.$router.push({
          name: "standing_category",
          params: {
            category: category.id,
          }
        });
      }
    },
    created() {
      this.load();
    }
  };

</script>

<style lang="scss" scoped>
  .list {
    margin-bottom: 25px;
    margin-top: 25px;
    width: 100%;

    .item {
      padding: 10px 25px;
      text-align: center;
      display: inline-block;
      cursor: pointer;
      border: 1px solid #ddd;
      text-transform: uppercase;

      &.selected {
        background: $main-color;
        //   font-family: AvantGarde;
        color: #fff;
        border-color: $main-color;
      }
    }
  }

  @media only screen and (max-width: 600px) {
    .list {
      .item {
        width: 25%;
        padding: 2px 5px;
      }
    }
  }

</style>
